const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

const unwrapPayload = (payload) => {
  let source = isObject(payload) ? payload : {};
  for (let depth = 0; depth < 2; depth += 1) {
    const nested = source.data;
    if (!isObject(nested) || 'mode' in source || 'sn' in source || 'key' in source) {
      break;
    }
    source = nested;
  }
  return source;
};

const integerOrNull = (value) => Number.isInteger(value) ? value : null;

export function validateExtraVinSn(value) {
  const sn = String(value ?? '').trim();
  return /^[A-Za-z0-9]{12}$/.test(sn)
    ? ''
    : '序列号必须是 12 位字母或数字';
}

export function validateExtraVinLimit(value, limits) {
  if (!Number.isInteger(value)) {
    return '每日 VIN 上限必须是整数';
  }

  const minimum = integerOrNull(limits?.minimum);
  const maximum = integerOrNull(limits?.maximum);
  if (minimum === null || maximum === null || minimum > maximum) {
    return '服务端未返回有效的限额范围';
  }
  if (value < minimum || value > maximum) {
    return `每日 VIN 上限必须在 ${minimum}–${maximum} 之间`;
  }
  return '';
}

export function normalizeExtraVinLimitPayload(payload = {}) {
  const source = unwrapPayload(payload);
  const mode = ['default', 'custom', 'invalid'].includes(source.mode)
    ? source.mode
    : '';

  return {
    sn: String(source.sn ?? '').trim(),
    key: String(source.key ?? ''),
    mode,
    configuredLimit: integerOrNull(source.configuredLimit),
    rawValue: String(source.rawValue ?? ''),
    defaults: {
      northAmerica: integerOrNull(source.defaults?.northAmerica),
      nonNorthAmerica: integerOrNull(source.defaults?.nonNorthAmerica),
    },
    limits: {
      minimum: integerOrNull(source.limits?.minimum),
      maximum: integerOrNull(source.limits?.maximum),
    },
  };
}
